import dw from '@src/plugins/direct-stat'
import { getQuery, getUtmSource } from '@util'
export default function useReport(dwId = 'company_alert_loginfailed') {
  const report = params => {
    dw.report(dwId, {
      source: getUtmSource(),
      medium: getQuery('utm_medium'),
      campaign: getQuery('utm_campaign'),
      content: getQuery('utm_content'),
      ...params,
    })
  }
  return {
    report,
  }
}
